export { default as MaterialsIndexPageCategoriesNavItem } from './MaterialsIndexPageCategoriesNavItem';
